import React, { useState } from "react";
import "./MobileModal.css";
import logo from "../images/Extractor logo.png";
import { BASE_URL } from "../App_Settings/app_settings";

export default function MobileModal() {
  const [showNotify, setShowNotify] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState("");

  // Example: handle email submit using a placeholder API (replace with real email service)
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setMessage("");
    try {
      const response = await fetch(`${BASE_URL}/Email/SendNotifyEmail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: name, email: email }),
      });
      if (response.ok) {
        setMessage("Thank you! We will notify you by email.");
        setName("");
        setEmail("");
      } else {
        setMessage("There was an error. Please try again.");
      }
    } catch (err) {
      setMessage("There was an error. Please try again.");
    }
    setSending(false);
  };

  return (
    <div className="mobile-modal-overlay" style={{ backgroundImage: "var(--login-bg-image)" }}>
      <div className="mobile-modal-card">
        <img src={logo} alt="logo" className="mobile-modal-logo" />
        {!showNotify ? (
          <>
            <p className="mobile-modal-text">
              Thank you for your interest in the Comply Extractor.
            </p>
            <p className="mobile-modal-text">
              Unfortunately, mobile devices aren't supported at this time.
              <br />
              Please visit this URL to explore our desktop version.
            </p>
            <p className="mobile-modal-text">
              Alternatively, you can visit our product page to learn more and schedule a demo!
            </p>
            <button
              className="mobile-modal-btn"
              onClick={() =>
                window.open(
                  "https://www.complyexchange.com/comply-extractor",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              Learn More
            </button>
            <button className="mobile-modal-btn" onClick={() => setShowNotify(true)}>
              Notify Me
            </button>
          </>
        ) : (
          <form onSubmit={handleEmailSubmit} style={{ width: "100%" }}>
            <p className="mobile-modal-text">
              Sign up now, and we'll email you a login code—ready for when you're back at your
              desktop!
            </p>
            <input
              className="mobile-modal-input"
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <input
              className="mobile-modal-input"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button className="mobile-modal-btn" type="submit" disabled={sending}>
              {sending ? "Sending..." : "Send"}
            </button>
            {message && (
              <div
                className="mobile-modal-text"
                style={{ color: message.startsWith("Thank") ? "green" : "red" }}
              >
                {message}
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
